import { render } from "./serve-card.vue?vue&type=template&id=47f7b658&scoped=true"
import script from "./serve-card.vue?vue&type=script&lang=js"
export * from "./serve-card.vue?vue&type=script&lang=js"

import "./serve-card.vue?vue&type=style&index=0&id=47f7b658&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f7b658"]])

export default __exports__